export const allProperties = [
  {
    id: 1,
    title: "Mountain Retreat in Rugova",
    location: "Rugova Valley, Kosovo",
    image: "/modern-mountain-cabin-with-valley-views-kosovo.jpg",
    memoryDensity: 94,
    memories: 127,
    topMemory: "Proposals",
    price: 89,
    rating: 4.9,
    reviews: 84,
    memoryHighlight: "12 couples got engaged here in the past year",
  },
  {
    id: 2,
    title: "Creative Loft in Pristina",
    location: "Pristina, Kosovo",
    image: "/modern-creative-loft-studio-with-large-windows.jpg",
    memoryDensity: 88,
    memories: 95,
    topMemory: "Creative Breakthroughs",
    price: 75,
    rating: 4.8,
    reviews: 62,
    memoryHighlight: "3 bestselling novels were started here",
  },
  {
    id: 3,
    title: "Lakeside Villa at Batllava",
    location: "Batllava Lake, Kosovo",
    image: "/beautiful-lakeside-villa-with-sunset-views.jpg",
    memoryDensity: 91,
    memories: 108,
    topMemory: "Family Reunions",
    price: 145,
    rating: 4.9,
    reviews: 73,
    memoryHighlight: "Perfect for multi-generational gatherings",
  },
  {
    id: 4,
    title: "Historic Stone House",
    location: "Prizren Old Town, Kosovo",
    image: "/historic-stone-house-in-old-town-prizren.jpg",
    memoryDensity: 89,
    memories: 142,
    topMemory: "Anniversaries",
    price: 95,
    rating: 4.7,
    reviews: 91,
    memoryHighlight: "18th century charm with modern comfort",
  },
  {
    id: 5,
    title: "Modern Studio Apartment",
    location: "Pristina City Center, Kosovo",
    image: "/modern-student-studio-apartment-bright.jpg",
    memoryDensity: 72,
    memories: 54,
    topMemory: "Career Milestones",
    price: 55,
    rating: 4.6,
    reviews: 38,
    memoryHighlight: "Where startups are born",
  },
  {
    id: 6,
    title: "Cozy Cottage in Brezovica",
    location: "Brezovica, Kosovo",
    image: "/cozy-cottage-with-mountain-backdrop.jpg",
    memoryDensity: 86,
    memories: 89,
    topMemory: "Personal Transformations",
    price: 78,
    rating: 4.8,
    reviews: 56,
    memoryHighlight: "Ski season romance destination",
  },
  {
    id: 7,
    title: "Traditional Stone Villa",
    location: "Decan, Kosovo",
    image: "/traditional-stone-house-kosovo.jpg",
    memoryDensity: 82,
    memories: 76,
    topMemory: "Proposals",
    price: 110,
    rating: 4.7,
    reviews: 45,
    memoryHighlight: "Authentic Kosovo architecture",
  },
  {
    id: 8,
    title: "Riverside Cabin",
    location: "White Drin River, Kosovo",
    image: "/riverside-cabin-kosovo-nature.jpg",
    memoryDensity: 79,
    memories: 63,
    topMemory: "Solo Adventures",
    price: 68,
    rating: 4.8,
    reviews: 41,
    memoryHighlight: "Nature immersion experience",
  },
  {
    id: 9,
    title: "Penthouse with City Views",
    location: "Pristina, Kosovo",
    image: "/modern-penthouse-pristina-skyline.jpg",
    memoryDensity: 85,
    memories: 92,
    topMemory: "Celebrations",
    price: 165,
    rating: 4.9,
    reviews: 67,
    memoryHighlight: "Panoramic views for special occasions",
  },
  {
    id: 10,
    title: "Eco Lodge in the Forest",
    location: "Germia Park, Kosovo",
    image: "/eco-lodge-forest-mountains.jpg",
    memoryDensity: 77,
    memories: 58,
    topMemory: "Personal Transformations",
    price: 85,
    rating: 4.6,
    reviews: 34,
    memoryHighlight: "Digital detox retreat",
  },
  {
    id: 11,
    title: "Vineyard Villa",
    location: "Rahovec, Kosovo",
    image: "/vineyard-villa-kosovo-wine-country.jpg",
    memoryDensity: 83,
    memories: 71,
    topMemory: "Anniversaries",
    price: 125,
    rating: 4.8,
    reviews: 52,
    memoryHighlight: "Wine country romance",
  },
  {
    id: 12,
    title: "Minimalist Modern Studio",
    location: "Pristina, Kosovo",
    image: "/minimalist-modern-studio-apartment.jpg",
    memoryDensity: 68,
    memories: 42,
    topMemory: "Creative Breakthroughs",
    price: 60,
    rating: 4.5,
    reviews: 29,
    memoryHighlight: "Designed for focused work",
  },
  {
    id: 13,
    title: "Ottoman Heritage House",
    location: "Prizren, Kosovo",
    image: "/ottoman-heritage-house-prizren.jpg",
    memoryDensity: 92,
    memories: 118,
    topMemory: "Family Reunions",
    price: 135,
    rating: 4.9,
    reviews: 78,
    memoryHighlight: "400 years of stories within these walls",
  },
  {
    id: 14,
    title: "Mountain Chalet",
    location: "Brezovica Ski Resort, Kosovo",
    image: "/mountain-chalet-ski-resort-brezovica.jpg",
    memoryDensity: 87,
    memories: 96,
    topMemory: "Proposals",
    price: 155,
    rating: 4.8,
    reviews: 64,
    memoryHighlight: "Ski-in ski-out luxury",
  },
  {
    id: 15,
    title: "Artist's Collective Loft",
    location: "Pristina Art District, Kosovo",
    image: "/artists-collective-loft-space-pristina.jpg",
    memoryDensity: 81,
    memories: 67,
    topMemory: "Creative Breakthroughs",
    price: 72,
    rating: 4.7,
    reviews: 43,
    memoryHighlight: "Gallery space included",
  },
  {
    id: 16,
    title: "Lakefront House",
    location: "Batllava, Kosovo",
    image: "/lakefront-house-batllava-kosovo.jpg",
    memoryDensity: 84,
    memories: 79,
    topMemory: "Family Reunions",
    price: 115,
    rating: 4.8,
    reviews: 51,
    memoryHighlight: "Private dock and boat access",
  },
  {
    id: 17,
    title: "Industrial Loft",
    location: "Mitrovica, Kosovo",
    image: "/contemporary-industrial-loft-mitrovica.jpg",
    memoryDensity: 69,
    memories: 38,
    topMemory: "Career Milestones",
    price: 58,
    rating: 4.5,
    reviews: 24,
    memoryHighlight: "Converted factory space",
  },
  {
    id: 18,
    title: "Garden Cottage",
    location: "Gjakova, Kosovo",
    image: "/garden-cottage-with-flowers-kosovo.jpg",
    memoryDensity: 76,
    memories: 55,
    topMemory: "First Dates",
    price: 65,
    rating: 4.7,
    reviews: 36,
    memoryHighlight: "Secret garden escape",
  },
  {
    id: 19,
    title: "Rooftop Suite",
    location: "Pristina, Kosovo",
    image: "/rooftop-suite-terrace-pristina-night.jpg",
    memoryDensity: 88,
    memories: 94,
    topMemory: "Celebrations",
    price: 145,
    rating: 4.9,
    reviews: 61,
    memoryHighlight: "Private terrace under the stars",
  },
  {
    id: 20,
    title: "Traditional Farmhouse",
    location: "Peja Region, Kosovo",
    image: "/traditional-farmhouse-kosovo-countryside.jpg",
    memoryDensity: 78,
    memories: 62,
    topMemory: "Family Reunions",
    price: 95,
    rating: 4.6,
    reviews: 39,
    memoryHighlight: "Farm-to-table experience",
  },
  {
    id: 21,
    title: "Hilltop Modern Villa",
    location: "Pristina Heights, Kosovo",
    image: "/hilltop-modern-villa-pristina-views.jpg",
    memoryDensity: 90,
    memories: 102,
    topMemory: "Proposals",
    price: 185,
    rating: 4.9,
    reviews: 72,
    memoryHighlight: "Sunset proposal hotspot",
  },
  {
    id: 22,
    title: "Monastery View Cottage",
    location: "Gracanica, Kosovo",
    image: "/monastery-view-cottage.jpg",
    memoryDensity: 85,
    memories: 81,
    topMemory: "Personal Transformations",
    price: 75,
    rating: 4.7,
    reviews: 48,
    memoryHighlight: "Spiritual retreat location",
  },
  {
    id: 23,
    title: "Urban Artist Studio",
    location: "Pristina, Kosovo",
    image: "/urban-artist-studio.jpg",
    memoryDensity: 74,
    memories: 53,
    topMemory: "Creative Breakthroughs",
    price: 62,
    rating: 4.6,
    reviews: 31,
    memoryHighlight: "Creative inspiration guaranteed",
  },
  {
    id: 24,
    title: "Valley View Retreat",
    location: "Rugova Valley, Kosovo",
    image: "/valley-view-retreat.jpg",
    memoryDensity: 91,
    memories: 115,
    topMemory: "Proposals",
    price: 120,
    rating: 4.9,
    reviews: 79,
    memoryHighlight: "Where dreams become reality",
  },
  {
    id: 25,
    title: "Cozy City Apartment",
    location: "Ferizaj, Kosovo",
    image: "/cozy-city-apartment.jpg",
    memoryDensity: 65,
    memories: 35,
    topMemory: "First Dates",
    price: 48,
    rating: 4.4,
    reviews: 22,
    memoryHighlight: "Perfect for short getaways",
  },
  {
    id: 26,
    title: "Mountain Peak Lodge",
    location: "Sharr Mountains, Kosovo",
    image: "/mountain-peak-lodge.jpg",
    memoryDensity: 93,
    memories: 124,
    topMemory: "Proposals",
    price: 175,
    rating: 4.9,
    reviews: 86,
    memoryHighlight: "Above the clouds romance",
  },
  {
    id: 27,
    title: "Historic Quarter Suite",
    location: "Prizren, Kosovo",
    image: "/historic-quarter-suite.jpg",
    memoryDensity: 86,
    memories: 88,
    topMemory: "Anniversaries",
    price: 105,
    rating: 4.8,
    reviews: 57,
    memoryHighlight: "Steps from ancient bridges",
  },
  {
    id: 28,
    title: "Wellness Retreat Cabin",
    location: "Germia Park, Kosovo",
    image: "/wellness-retreat-cabin.jpg",
    memoryDensity: 80,
    memories: 68,
    topMemory: "Personal Transformations",
    price: 98,
    rating: 4.7,
    reviews: 44,
    memoryHighlight: "Mindfulness and nature combined",
  },
  {
    id: 29,
    title: "Artisan Workshop Loft",
    location: "Gjakova Bazaar, Kosovo",
    image: "/artisan-workshop-loft.jpg",
    memoryDensity: 75,
    memories: 52,
    topMemory: "Creative Breakthroughs",
    price: 68,
    rating: 4.6,
    reviews: 33,
    memoryHighlight: "Above the historic bazaar",
  },
  {
    id: 30,
    title: "Countryside Manor",
    location: "Lipjan, Kosovo",
    image: "/countryside-manor.jpg",
    memoryDensity: 82,
    memories: 74,
    topMemory: "Family Reunions",
    price: 155,
    rating: 4.8,
    reviews: 49,
    memoryHighlight: "Elegant family gatherings",
  },
  {
    id: 31,
    title: "Writer's Hideaway",
    location: "Rugova Valley, Kosovo",
    image: "/writers-hideaway.jpg",
    memoryDensity: 87,
    memories: 91,
    topMemory: "Creative Breakthroughs",
    price: 82,
    rating: 4.8,
    reviews: 58,
    memoryHighlight: "Where stories come to life",
  },
  {
    id: 32,
    title: "Romantic Tower Suite",
    location: "Prizren Castle Area, Kosovo",
    image: "/romantic-tower-suite.jpg",
    memoryDensity: 95,
    memories: 138,
    topMemory: "Proposals",
    price: 165,
    rating: 4.9,
    reviews: 94,
    memoryHighlight: "Fairytale proposal setting",
  },
  {
    id: 33,
    title: "Zen Garden House",
    location: "Peja, Kosovo",
    image: "/zen-garden-house.jpg",
    memoryDensity: 79,
    memories: 61,
    topMemory: "Personal Transformations",
    price: 88,
    rating: 4.7,
    reviews: 40,
    memoryHighlight: "Japanese-inspired tranquility",
  },
  {
    id: 34,
    title: "Adventure Base Camp",
    location: "Brezovica, Kosovo",
    image: "/adventure-base-camp.jpg",
    memoryDensity: 73,
    memories: 49,
    topMemory: "Solo Adventures",
    price: 72,
    rating: 4.6,
    reviews: 32,
    memoryHighlight: "Gateway to mountain adventures",
  },
  {
    id: 35,
    title: "Sunflower Farmstead",
    location: "Rahovec, Kosovo",
    image: "/sunflower-farmstead.jpg",
    memoryDensity: 77,
    memories: 56,
    topMemory: "Family Reunions",
    price: 92,
    rating: 4.7,
    reviews: 37,
    memoryHighlight: "Golden fields of memories",
  },
  {
    id: 36,
    title: "Modern Minimalist House",
    location: "Pristina, Kosovo",
    image: "/modern-minimalist-house.jpg",
    memoryDensity: 71,
    memories: 45,
    topMemory: "Career Milestones",
    price: 125,
    rating: 4.6,
    reviews: 28,
    memoryHighlight: "Designed for success",
  },
  {
    id: 37,
    title: "Riverside Glamping Tent",
    location: "Mirusha Waterfalls, Kosovo",
    image: "/riverside-glamping-tent.jpg",
    memoryDensity: 84,
    memories: 78,
    topMemory: "First Dates",
    price: 95,
    rating: 4.8,
    reviews: 53,
    memoryHighlight: "Luxury meets wilderness",
  },
  {
    id: 38,
    title: "Heritage Wine Cellar Suite",
    location: "Rahovec, Kosovo",
    image: "/heritage-wine-cellar-suite.jpg",
    memoryDensity: 81,
    memories: 66,
    topMemory: "Anniversaries",
    price: 118,
    rating: 4.7,
    reviews: 42,
    memoryHighlight: "Toast to your love story",
  },
  {
    id: 39,
    title: "Treehouse Escape",
    location: "Germia Forest, Kosovo",
    image: "/treehouse-escape.jpg",
    memoryDensity: 89,
    memories: 97,
    topMemory: "Proposals",
    price: 135,
    rating: 4.9,
    reviews: 68,
    memoryHighlight: "Elevated romance experience",
  },
  {
    id: 40,
    title: "Old Town Terrace Flat",
    location: "Prizren, Kosovo",
    image: "/old-town-terrace-flat.jpg",
    memoryDensity: 83,
    memories: 72,
    topMemory: "First Dates",
    price: 78,
    rating: 4.7,
    reviews: 46,
    memoryHighlight: "Rooftop sunset views",
  },
  {
    id: 41,
    title: "Meditation Sanctuary",
    location: "Sharr Mountains, Kosovo",
    image: "/meditation-sanctuary.jpg",
    memoryDensity: 86,
    memories: 84,
    topMemory: "Personal Transformations",
    price: 105,
    rating: 4.8,
    reviews: 55,
    memoryHighlight: "Find your inner peace",
  },
  {
    id: 42,
    title: "Family Estate Home",
    location: "Ferizaj, Kosovo",
    image: "/family-estate-home.jpg",
    memoryDensity: 78,
    memories: 59,
    topMemory: "Family Reunions",
    price: 145,
    rating: 4.6,
    reviews: 35,
    memoryHighlight: "Space for everyone you love",
  },
  {
    id: 43,
    title: "Photographer's Paradise",
    location: "Mirusha Canyon, Kosovo",
    image: "/photographers-paradise.jpg",
    memoryDensity: 82,
    memories: 69,
    topMemory: "Creative Breakthroughs",
    price: 88,
    rating: 4.7,
    reviews: 41,
    memoryHighlight: "Every angle is Instagram-worthy",
  },
  {
    id: 44,
    title: "Stargazer's Dome",
    location: "Rugova Valley, Kosovo",
    image: "/stargazers-dome.jpg",
    memoryDensity: 92,
    memories: 112,
    topMemory: "Proposals",
    price: 158,
    rating: 4.9,
    reviews: 76,
    memoryHighlight: "Pop the question under the stars",
  },
  {
    id: 45,
    title: "Boutique City Hotel",
    location: "Pristina Center, Kosovo",
    image: "/boutique-city-hotel.jpg",
    memoryDensity: 70,
    memories: 43,
    topMemory: "Career Milestones",
    price: 95,
    rating: 4.5,
    reviews: 27,
    memoryHighlight: "Business meets pleasure",
  },
  {
    id: 46,
    title: "Countryside Wellness Spa",
    location: "Peja Region, Kosovo",
    image: "/countryside-wellness-spa.jpg",
    memoryDensity: 85,
    memories: 82,
    topMemory: "Personal Transformations",
    price: 135,
    rating: 4.8,
    reviews: 54,
    memoryHighlight: "Rejuvenation destination",
  },
  {
    id: 47,
    title: "Historic Mill House",
    location: "Gjakova, Kosovo",
    image: "/historic-mill-house.jpg",
    memoryDensity: 80,
    memories: 64,
    topMemory: "Anniversaries",
    price: 102,
    rating: 4.7,
    reviews: 40,
    memoryHighlight: "Centuries of flowing love",
  },
  {
    id: 48,
    title: "Alpine Summit Retreat",
    location: "Sharr Mountains, Kosovo",
    image: "/alpine-summit-retreat.jpg",
    memoryDensity: 94,
    memories: 129,
    topMemory: "Proposals",
    price: 195,
    rating: 4.9,
    reviews: 88,
    memoryHighlight: "Top of the world moments",
  },
]
